import React, { useEffect, useRef } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import '../styles/Navbar.css';

function CustomNavbar() {
    const location = useLocation();
    const navigate = useNavigate();
    const navRef = useRef(null); // Ref to control navbar collapse

    useEffect(() => {
        const onScroll = () => {
            const navbar = document.getElementById('custom-navbar');
            if (window.scrollY > 50) {
                navbar.classList.add('navbar-scrolled');
            } else {
                navbar.classList.remove('navbar-scrolled');
            }
        };

        window.addEventListener('scroll', onScroll);
        onScroll();
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [location]);

    const isActive = (path) => location.pathname === path;

    const handleNavClick = (path) => (e) => {
        e.preventDefault();
        
        // Scroll to top immediately for better UX
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
        
        // Close mobile navbar if open
        if (navRef.current) {
            const navbarToggler = document.querySelector('.navbar-toggler');
            const navbarCollapse = document.querySelector('.navbar-collapse');
            
            // Check if navbar is expanded (mobile view)
            if (navbarCollapse && navbarCollapse.classList.contains('show')) {
                // Trigger click on toggler to close it
                navbarToggler.click();
            }
        }
        
        // Then navigate
        navigate(path);
    };

    return (
        <Navbar id="custom-navbar" expand="lg" fixed="top" ref={navRef} collapseOnSelect>
            <Container className="navbar-inner">
                <Navbar.Brand 
                    href="/" 
                    onClick={handleNavClick('/')}
                    className="logo-container" 
                >
                    <div className="logo-wrapper">
                        <img
                            src="/law_icon_2.png"
                            className="navbar-logo"
                            alt=""
                        />
                        <div className="brand-wordmark">
                            <span className="brand-name">
                                Ziyad <span className="brand-name-accent">Attorneys</span>
                            </span>
                        </div>
                    </div>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto ms-auto">
                        <Nav.Link 
                            href="/" 
                            onClick={handleNavClick('/')} 
                            className={isActive('/') ? 'active-link' : ''}
                        >
                            Home
                        </Nav.Link>
                        <Nav.Link 
                            href="/about" 
                            onClick={handleNavClick('/about')} 
                            className={isActive('/about') ? 'active-link' : ''}
                        >
                            About Us
                        </Nav.Link>
                        <Nav.Link 
                            href="/services" 
                            onClick={handleNavClick('/services')} 
                            className={isActive('/services') ? 'active-link' : ''}
                        >
                            Services
                        </Nav.Link>
                        <Nav.Link 
                            href="/contact" 
                            onClick={handleNavClick('/contact')} 
                            className={isActive('/contact') ? 'active-link' : ''}
                        >
                            Contact Us
                        </Nav.Link>
                        <Nav.Link 
                            href="/blog" 
                            onClick={handleNavClick('/blog')} 
                            className={isActive('/blog') ? 'active-link' : ''}
                        >
                            Blog
                        </Nav.Link>                        
                        <Nav.Link 
                            href="/resources" 
                            onClick={handleNavClick('/resources')} 
                            className={isActive('/resources') ? 'active-link' : ''}
                        >
                            Resources
                        </Nav.Link>
                        <Nav.Link href="tel:+251913811743" className="nav-phone-cta">
                            <FontAwesomeIcon icon={faPhone} /> (+251) 913 81 17 43
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default CustomNavbar;

